
<template>
    <div>
        <b-carousel
            id="carousel-slide"
            :interval="5000"
            class="system-message-carousel mt-n4 border rounded mb-3 card"
            style="text-shadow: 0px 0px 2px #000"
            slide
            img-width="1024"
            img-height="480"
        >
            <b-carousel-slide
              v-for="msg in messages"
              :key="msg.id"
            >
            <p class="mb-0 row no-margin">
                <span class="col-md-2 text-left align-self-center">
                    <span class="badge-pill mr-3 green-bg" v-if="msg.priority === 0">{{types[msg.type].text}}</span>
                    <span class="badge-pill mr-3 orange-bg" v-if="msg.priority === 1">{{types[msg.type].text}}</span>
                    <span class="badge-pill mr-3 red-bg" v-if="msg.priority === 2">{{types[msg.type].text}}</span>
                </span>
                <span class="col-md-8">{{msg.message}}</span>
                <span class="col-md-2 align-self-center text-right"><b-button v-on:click="hidemessage()" class="msg-dismiss-btn btn-primary btn"><b-icon variant="" icon="x-octagon-fill" scale="1" width="15px" height="15px" class="mr-2 align-middle" style="margin-top: -2px;"></b-icon>Dismiss</b-button></span>
            </p>
            </b-carousel-slide>
        </b-carousel>
    </div>
</template>
<script>
    export default{
        mounted() {
            
        },
        props: [],
        data(){            
            
            return {
                cu : window.location.href,
                ce : false, 
                
                messages : [],
                
                types: [                    
                    { value: "0", text: "Info" },
                    { value: "1", text: "Notice" },
                    { value: "2", text: "Message" },
                    { value: "3", text: "Alert" },
                ],
                
            }
        },
        methods:{
            
            getMessages: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/system/message/list/active' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.messages = response.data;
                    
                    /*this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true,
                                            toaster: 'b-toaster-top-full',
                                        });*/



                }.bind(this));
            },
            hidemessage(){
                //alert('test');
                let msgbody = document.querySelector('.message-container');
                msgbody.style.display = "none";
                this.$cookies.set("showmessage", "none");
            }


        },
        created: function(){
            this.getMessages();            
        },
    }
</script>

 